import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    columns: [
            "name.en",
        ],
    loading: true,
    allLoaded : false,
    addNew : false,
    transportHeader: [
        {
            is : ["EXW"],
            name : {
              en: "EX Works / Stock",
              de: "Ab Werk / Lager",
            },
            icon : "/images/uxwing.com/factory-icon.svg",
        },
        {
            is : ["FCA"],
            name : {
              en: "Unloading",
              de: "Entladen",
            },
            icon : "/images/uxwing.com/truck-icon.svg",
        },
        {
            is : ["FAS"],
            name : {
              en: "Loading at export Port",
              de: "Verladung im Exporthafen",
            },
            icon : "/images/uxwing.com/crane-icon.svg",
        },
        {
            is : ["FOB", "COB"],
            name : {
              en: "Transit to destination",
              de: "Transit zum Zielort",
            },
            icon : "/images/uxwing.com/cruise-icon.svg",
        },
        {
            is: ["CIF"],
            name : {
              en: "Cargo Insuarance",
              de: "Versicherung der Fracht"
            },
            icon : "/images/uxwing.com/travel-insurance-icon.svg",
        },
        {
            is: ["CIF", "CFR", "DUP"],
            name : {
              en: "Unloading at import",
              de: "Entladung bei der Einfuhr"
            },
            icon : "/images/uxwing.com/forklift-icon.svg",
        },
        {
            is: ["CPT", "CIP"],
            name : {
              en: "Loading Truck",
              de: "Lkw beladen"
            },
            icon : "/images/uxwing.com/logistic-truck-icon.svg",
        },
        {
            is: ["DAP"],
            name : {
              en: "Carriage to Destination",
              de: "Beförderung zum Zielort"
            },
            icon : "/images/uxwing.com/company-enterprise-icon.svg",
        },
        {
            is: [],
            name : {
              en: "Import customs clearance",
              de: "Importzollabfertigung"
            },
            icon : "/images/uxwing.com/immigration-check-sign-icon.svg",
        },
        {
            is: [],
            name : {
              en: "Import Duties",
              de: "Importabgaben"
            },
            icon : "/images/uxwing.com/income-taxes-icon.svg",
        },
    ]
})

  // getters
  const getters = {
      findById  : (state) => (id) =>{
          return state.list.find(item => item.id == id);
      }
  }

  // actions
  const actions = {
  }

  // mutations
  const mutations = {
      set(state, list){
          state.list = list;
      },
      loadingStatus(state, status){
          state.loading = status;
      },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
